module.exports = __webpack_public_path__ + "static/media/5DPO18.fa6204b5.jpg";